import reportCategories from './reportCategories';

const reportTypes = {
    [reportCategories.SKATERS]: [{
        label: 'Summary',
        value: 'skater/summary'
    }, {
        label: 'Assists',
        value: 'skater/assists'
    }, {
        label: 'Bios',
        value: 'skater/bios'
    }, {
        label: 'Division (1926-37, 1967-Present)',
        value: 'skater/division'
    }, {
        label: 'Faceoff Leaders (Since 1997-98)',
        value: 'skater/faceoff-leaders'
    }, {
        label: 'Faceoffs (Since 1997-98)',
        value: 'skater/faceoffs'
    }, {
        label: 'Goals',
        value: 'skater/goals'
    }, {
        label: 'Home',
        value: 'skater/home'
    }, {
        label: 'Penalties',
        value: 'skater/penalties'
    }, {
        label: 'Plus/Minus (Since 1959-60)',
        value: 'skater/plus-minus'
    }, {
        label: 'Points',
        value: 'skater/points'
    }, {
        label: 'Points by Strength (Since 1933-34)',
        value: 'skater/points-by-strength'
    }, {
        label: 'Real Time (Since 2002-03)',
        value: 'skater/real-time'
    }, {
        label: 'Road',
        value: 'skater/road'
    }, {
        label: 'Shooting Percentage Leaders (Since 1979-1980)',
        value: 'skater/shooting-percentage-leaders'
    }, {
        label: 'Shooting Percentage (Since 1959-60)',
        value: 'skater/shooting-percentage'
    }, {
        label: 'Shootout (Since 2005-06)',
        value: 'skater/shootout'
    }, {
        label: 'Time On Ice  (Since 1997-98)',
        value: 'skater/time-on-ice'
    }],
    [reportCategories.GOALIES]: [{
        label: 'Summary',
        value: 'goalie/summary'
    }, {
        label: 'Bios',
        value: 'goalie/bios'
    }, {
        label: 'Goals-Against Average Leaders',
        value: 'goalie/goals-against-average-leaders'
    }, {
        label: 'Goals-Against Average',
        value: 'goalie/goals-against-average'
    }, {
        label: 'Home',
        value: 'goalie/home'
    }, {
        label: 'Penalty Shots (Since 1997-98)',
        value: 'goalie/penalty-shots'
    }, {
        label: 'Road',
        value: 'goalie/road'
    }, {
        label: 'Save Percentage Leaders (Since 1955-56)',
        value: 'goalie/save-percentage-leaders'
    }, {
        label: 'Save Percentage (Since 1955-56)',
        value: 'goalie/save-percentage'
    }, {
        label: 'Shootouts (Since 2005-06)',
        value: 'goalie/shootouts'
    }, {
        label: 'Special Teams (Since 1955-56)',
        value: 'goalie/special-teams'
    }],
    [reportCategories.TEAMS]: [{
        label: 'Summary',
        value: 'team/summary'
    }, {
        label: 'Games Decided in OT/SO (Since 2005-06)',
        value: 'team/games-decided-in-ot-so'
    }, {
        label: 'Goal-Games',
        value: 'team/goal-games'
    }, {
        label: 'Goals Against (By Strength, Since 1987-1988)',
        value: 'team/goals-against'
    }, {
        label: 'Goals at Home/Road',
        value: 'team/goals-home-road'
    }, {
        label: 'Goals by Period',
        value: 'team/goals-by-period'
    }, {
        label: 'Goals For (By Strength, Since 1987-1988)',
        value: 'team/goals-for'
    }, {
        label: 'Home',
        value: 'team/home'
    }, {
        label: 'Leading/Trailing',
        value: 'team/leading-trailing'
    }, {
        label: 'Time Leading/Trailing',
        value: 'team/time-leading-trailing'
    }, {
        label: 'Outshoot/Outshot By (Since 1959-60)',
        value: 'team/outshoot-outshot-by'
    }, {
        label: 'Penalties',
        value: 'team/penalties'
    }, {
        label: 'Penalty Kill (Since 1977-78)',
        value: 'team/penalty-kill'
    }, {
        label: 'Plus/Minus',
        value: 'team/plus-minus'
    }, {
        label: 'Posts/Crossbars (Since 2009-10)',
        value: 'team/posts-crossbars'
    }, {
        label: 'Power Play (Since 1977-78)',
        value: 'team/powerplay'
    }, {
        label: 'Power-Play Time (Since 2009-10)',
        value: 'team/powerplay-time'
    }, {
        label: 'Real Time (Since 1997-98)',
        value: 'team/real-time'
    }, {
        label: 'Records in Back-to-Back Games',
        value: 'team/records-in-back-to-back-games'
    }, {
        label: 'Road',
        value: 'team/road'
    }, {
        label: 'Save Percentage (Since 1955-56)',
        value: 'team/save-percentage'
    }, {
        label: 'Score/Trail First',
        value: 'team/score-trail-first'
    }, {
        label: 'Scoring by Defensemen',
        value: 'team/scoring-by-defensemen'
    }, {
        label: 'Scoring by Forwards',
        value: 'team/scoring-by-forwards'
    }, {
        label: 'Scoring by Goalies',
        value: 'team/scoring-by-goalies'
    }, {
        label: 'Scoring by Rookies',
        value: 'team/scoring-by-rookies'
    }, {
        label: 'Shootouts (Since 2005-06)',
        value: 'team/shootouts'
    }, {
        label: 'Shots by Period (Since 1997-1998)',
        value: 'team/shots-by-period'
    }, {
        label: 'Special Teams Time Differential (Since 2002-03)',
        value: 'team/penalty-kill-time'
    }, {
       label: 'Comeback Wins',
       value: 'team/comeback-wins'
    }],
    [reportCategories.GAMES]: [{
        label: 'Summary',
        value: 'game/summary'
    }, {
        label: 'Game by Game',
        value: 'game/game-by-game'
    }, {
        label: 'OT and Shootout Games',
        value: 'game/overtime-and-shootout-games'
    }, {
        label: 'Penalties by Game',
        value: 'game/penalties-by-game'
    }, {
        label: 'Shutouts',
        value: 'game/shutouts'
    }],
    [reportCategories.SKATER_CAREER]: [{
        label: 'Career Leaders',
        value: 'skater-career/career-leaders'
    }, {
        label: 'Career Leaders for Franchise',
        value: 'skater-career/career-leaders-for-franchise'
    }, {
        label: 'Career Overtime',
        value: 'skater-career/career-overtime'
    }, {
        label: 'Career Penalty Shots',
        value: 'skater-career/career-penalty-shots'
    }, {
        label: 'Career Shootout Leaders (Since 2005-2006)',
        value: 'skater-career/career-shootout-leaders'
    }, {
        label: 'Single-Season Leaders',
        value: 'skater-career/single-season-leaders'
    }, {
        label: 'Single-Season Leaders for Franchise',
        value: 'skater-career/single-season-leaders-for-franchise'
    }],
    [reportCategories.GOALIE_CAREER]: [{
        label: 'Career Leaders',
        value: 'goalie-career/career-leaders'
    }, {
        label: 'Career Leaders for Franchise',
        value: 'goalie-career/career-leaders-for-franchise'
    }, {
        label: 'Career Overtime (Since 2005-2006)',
        value: 'goalie-career/career-overtime',
    }, {
        label: 'Career Penalty Shots',
        value: 'goalie-career/career-penalty-shots'
    }, {
        label: 'Career Shootout Leaders (Since 2005-2006)',
        value: 'goalie-career/career-shootout-leaders'
    }, {
        label: 'Single-Season Leaders',
        value: 'goalie-career/single-season-leaders'
    }, {
        label: 'Single-Season Leaders for Franchise',
        value: 'goalie-career/single-season-leaders-for-franchise'
    }],
    [reportCategories.LEAGUE]: [{
        label: 'Games Decided in OT/SO (Since 2005-06)',
        value: 'league/games-decided-in-ot-so',
    }, {
        label: 'Goals',
        value: 'league/goals',
    }, {
        label: 'Penalty Shots',
        value: 'league/penalty-shots'
    }, {
        label: 'Comeback Wins',
        value: 'league/comeback-wins'
    }],
    [reportCategories.HEAD_COACH]: [{
        label: 'Career',
        value: 'head-coach/career',
    }],
    [reportCategories.FRANCHISE]: [{
        label: 'All-Time Standings',
        value: 'franchise/all-time-standings',
    }, {
        label: 'All-Time Overtime',
        value: 'franchise/all-time-overtime',
    }, {
        label: 'All-Time Game 7',
        value: 'franchise/all-time-game-7',
    }, {
        label: 'All-Time Penalty Shots',
        value: 'franchise/all-time-penalty-shots',
    }],
    [reportCategories.MISCELLANEOUS]: [{
        label: 'Penalty Shots',
        value: 'miscellaneous/penalty-shots',
    }]
};

Object.values(reportTypes).forEach((values) => {
    values.sort((a, b) => {
        if (a.label === 'Summary') {
            return -1;
        } else if (b.label === 'Summary') {
            return 1;
        }
        return a.label.localeCompare(b.label);
    });
});

export default reportTypes;
